import _ from "lodash"

export default class Matrix {
    material: string

    species: string

    label: string

    enabled: boolean

    public static matrixLabel(matrix: Matrix): string {
        return `${_.capitalize(matrix.species)} ${
            matrix.label || matrix.material
        }`
    }
}
